
function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = 'hidden'
  }, 500)
  window.removeEventListener('transitionend', bodyOverflow)
}


function toggleCart() {
  const container = document.querySelector('#CartContainer')
  if (container.classList.contains('is-open')) {
    container.querySelector('.cart').style.transform = 'translateX(100%)'
    setTimeout(() => {
      container.classList.remove('is-open')
    }, 350)
    document.body.style.overflow = ''
  } else {
    container.classList.add('is-open')
    bodyOverflow()
    setTimeout(() => {
      container.querySelector('.cart').style.transform = 'translateX(0%)'
    }, 0)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(['.cart__underlay', '.close-cart']).forEach(item => item.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    toggleCart()
  }))
})

if (!customElements.get('open-cart')) {
  customElements.define('open-cart', class OpenCart extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', () => {
        console.log('toggle cart')
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.price-remove .remove').addEventListener('click', (event) => {
        event.target.classList.add('free-gift-loading')

        CartJS.removeItem(event.target.closest('cart-item').getAttribute('data-line'), {
          success: () => updateCart()
        })
      })

      this.querySelector('.qty-wrapper .minus').addEventListener('click', () => {
        this.querySelector('input').stepDown()
        this.updateQuantity()
      })
      this.querySelector('.qty-wrapper .plus').addEventListener('click', () => {
        this.querySelector('input').stepUp()
        this.updateQuantity()
      })
    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        this.querySelector('.price-remove .remove').classList.add('free-gift-loading')
        CartJS.updateItem(this.getAttribute('data-line'), this.querySelector('input').value, {
          success: () => updateCart()
        })
        this.timeout = null
      }, 300)
    }
  })
}

if (!customElements.get('cart-header')) {
  customElements.define('cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.close-cart').addEventListener('click', event => {
        toggleCart()
      })
    }
  })
}
